import { Icon, Input } from 'antd';
import React, { useState } from 'react';

const SelectEditable = ({
    options,
    width,
    onValue,
    disabled
}) => {

    const [open, setOpen] = useState(false)
    const [value, setValue] = useState()

    const handleOnChange = (value) => {
        onValue(value)
        setValue(value)
    }

    return (
      <div style={{position:'relative'}}>
        <Input 
        title={value}
        value={value} 
        style={{ width: width }} 
        disabled={disabled}
        onChange={(e)=> handleOnChange(e.target.value)}
        addonAfter={<Icon type="down" style={{  transform: !!open ? 'rotate(180deg)': '' }} onClick={()=> setOpen(!open)}/>} />
       {!!open && 
        <ul role="listBox"
        className='ant-select-dropdown-menu  ant-select-dropdown-menu-root ant-select-dropdown-menu-vertical'
        style={{display:'block',position:'absolute', zIndex:100,  width:width,backgroundColor:'white',
        maxHeight:250, overflow:'auto',
        boxShadow: `0 2px 8px rgba(0, 0, 0, 0.15)`
        }}>
         {options && options.map((e, index) => (
           <li 
           key={`li_${e}_${index}`}
           className='ant-select-dropdown-menu-item' onClick={()=>{ 
             onValue(`[${e}]`)
             setValue(`[${e}]`)
             setOpen(false)
            }}>{e}</li>
         ))}
         </ul>}
      </div>
    )
}

export default SelectEditable